import { createAction, createStandardAction, action } from 'typesafe-actions'
import { createErrorAction } from '@chegg-wt/core/utils/actions'
import { Citation, BaseCitation } from '@chegg-wt/core/types/redux-citation-api'
import { AutociteMetadataInput } from '@chegg-wt/core/globalTypesOneGraph'
import { ActionTypes, ValidatorStates } from './constants'
import { ValidatorState, CitationSuccessPayload } from './types'

/**
 * Used in EvalPage, FormPage and BibliographyPage to know which citation is "active".
 * In the latter, this is the citation active when clicked on Inline-Citation, Footnote, Copy, etc
 * Stored in `state.citation.activeCitation`.
 * @param {object} citation
 * @param {string} validatorStatus
 */
export const citationLoaded = createAction(ActionTypes.CITATION_LOAD, (action) => {
  // citation is `any` until we can more confidently type it
  return (
    citation: any,
    query: string,
    autociteRioTrackingID?: string,
    autociteResponseForRio?: AutociteMetadataInput
  ) =>
    action({
      citation,
      query,
      autociteRioTrackingID,
      autociteResponseForRio,
    })
})

export const citationValidated = createAction(
  ActionTypes.CITATION_VALIDATED,
  (action) => {
    return (validatorStatus: ValidatorState = ValidatorStates.COMPLETE) =>
      action({ validatorStatus })
  }
)

export const unloadCitation = createStandardAction(ActionTypes.CITATION_UNLOAD)()

export const citationCreate = createAction(ActionTypes.CITATION_CREATE, (action) => {
  // citationData is `any` until we can more confidently type it
  return (citationData: any, annotationText: string) =>
    action({ citationData, annotationText })
})

export const citationCreateSucceeded = createStandardAction(
  ActionTypes.CITATION_CREATE_SUCCEEDED
)<CitationSuccessPayload>()

export const citationCreateFailed = createErrorAction(ActionTypes.CITATION_CREATE_FAILED)

export const citationUpdate = createAction(
  ActionTypes.CITATION_UPDATE,
  (action) => (
    initialCitation: Citation,
    citationData: BaseCitation,
    annotationText: string
  ) => action({ initialCitation, citationData, annotationText })
)

export const citationUpdateSucceeded = createStandardAction(
  ActionTypes.CITATION_UPDATE_SUCCEEDED
)<CitationSuccessPayload>()

export const citationUpdateFailed = createErrorAction(ActionTypes.CITATION_UPDATE_FAILED)

// validator actions
export const ignoreIncompleteCitation = (origin: string) =>
  action(ActionTypes.IGNORE_INCOMPLETE_CITATION, { origin })

export const addAutociteRioMetadata = (
  autociteRioTrackingID?: string,
  autociteResponseForRio?: AutociteMetadataInput
) =>
  action(ActionTypes.ADD_AUTOCITE_METADATA, {
    autociteRioTrackingID,
    autociteResponseForRio,
  })
